import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
import { IAppConfig } from './models/app-config.model';
import { Injectable } from '@angular/core';

@Injectable()
export class AppConfig {
  static settings: IAppConfig;
  constructor(private http: HttpClient) {}
  load() {
    let jsonFile;
    if (environment.externalConfigDomain) {
      console.log(`Loading config from external domain: ${environment.externalConfigDomain}`);
      jsonFile = `${environment.externalConfigDomain}/assets/config/config.${environment.name}.json`;
    } else {
      jsonFile = `assets/config/config.${environment.name}.json`;
    }
    return new Promise<void>((resolve, reject) => {
      this.http
        .get(jsonFile)
        .toPromise()
        .then((response: IAppConfig) => {
          AppConfig.settings = <IAppConfig>response;
          resolve();
        })
        .catch((response: any) => {
          reject(
            `Could not load file '${jsonFile}': ${JSON.stringify(response)}`
          );
        });
    });
  }
}
